import React, { useState } from 'react';
import Style from './BaseLayout.module.scss'
import Navbar from "./Navbar";
import { Box } from "@mui/material";
import SinglePageRoutes from './SinglePageRoutes';
import useScrollObserver from '../hooks/useScrollObserver';

export default function BaseLayout() {
   const [active, setActive] = useState('about');
   const refAbout = useScrollObserver(setActive);
   const refWritings = useScrollObserver(setActive);
   const refPortfolio = useScrollObserver(setActive);
   const refContact = useScrollObserver(setActive);

   return (
      <Box className={Style.container}>
         <Navbar active={active} setActive={setActive} />
         <Box component={'main'} className={Style.main}>
            <SinglePageRoutes refs={{refAbout, refWritings, refPortfolio, refContact}}/>
         </Box>
      </Box>
   )
}
